import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CardContainerContentBaseComponent } from '@resident-nx/shared';

@Component({
  selector: 'rs-web-cards-container-content',
  templateUrl: './cards-container-content.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./cards-container-content.component.scss'],
})
export class CardsContainerContentWebComponent extends CardContainerContentBaseComponent {}
